import React, { useEffect } from "react"
import { useIntl } from "react-intl"
import { Divider } from "@mui/material"
import { Helmet } from "react-helmet"
import { useDispatch } from "react-redux"

import TopSummary from "organisms/top/Summary"
import TopContents from "organisms/top/Contents"
import TopInformation from "organisms/top/Information"
import { getTopPagePath } from "locale.js"
import useAgreements from "hooks/useAgreements"
import useDAuth from "hooks/useDAuth"
import { getUserAgreementsStatus } from "actions"
import TopAgreementsModal from "organisms/top/TopAgreementsModal"

const AGREEMENT_NOT_EXISTS = "-"

const Top = () => {
  const dispatch = useDispatch()
  const { overallAgreements, storeTopAgreementsDialogIsOpen } = useAgreements()

  // タブタイトルの作成
  const intl = useIntl()
  const title1 = intl.formatMessage({ id: "TopSummary.TabTitle" })
  const title2 = intl.formatMessage({ id: "Tab.Title" })
  const title = title1 + " | " + title2
  const { isAuthentication } = useDAuth()

  const url = `${process.env.REACT_APP_D_AUTH_LOGOUT_NL}`

  useEffect(() => {
    document.title = title
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: "Pageview",
      pagePath: getTopPagePath(),
      pageTitle: document.title,
    })
    window.scrollTo(0, 0)
  }, [title])

  useEffect(() => {
    if (
      isAuthentication &&
      !(overallAgreements.userAgreementsStatus ?? false)
    ) {
      dispatch(getUserAgreementsStatus())
    } else if (
      overallAgreements.userAgreementsStatus === AGREEMENT_NOT_EXISTS
    ) {
      dispatch(storeTopAgreementsDialogIsOpen(true))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [overallAgreements.userAgreementsStatus])
  return (
    <>
      <Divider />
      <TopSummary />
      <Divider />
      <TopContents />
      <Divider />
      <TopInformation />
      <Helmet>
        <link rel="canonical" href={url} />
      </Helmet>
      <TopAgreementsModal />
    </>
  )
}
export default Top
